<template>
    <div class="wrapper">
        <div class="order-wrap">
            <div class="order-head order-box">
                <div class="order-info">商品</div>
                <div class="order-price">单价</div>
                <div class="order-num">订单类型</div>
                <div class="order-total-price">退款金额</div>
                <div class="order-state">售后状态</div>
                <div class="order-handle">操作</div>
            </div>
            <div v-if="list.length==0">暂无租赁订单</div>
            <div class="order-item" v-for="(item,index) in list" :key="index">
                <div class="order-item-head">
                    <span class="time">{{timeToValue(item.ctime)}}</span>
                    售后号：
                    <span class="code">{{item.curaftersales&&item.curaftersales.aftersales_id}}</span>
                    订单号：
                    <span class="code">{{item.order_id}}</span>
                </div>
                <div class="order-item-main order-box">
                    <div class="order-info-list">
                        <div v-if="item.order_type==9" class="order-li">
                            <div class="order-img"></div>
                            <div class="order-name">{{JSON.parse(item.memo).from_meeting_name}}</div>
                            <div class="order-price">￥{{item.order_amount}}</div>
                        </div>
                        <div v-else class="order-li" v-for="(goods,i) in item.items" :key="i">
                            <img :src="goods.image_url" alt class="order-img">
                            <div class="order-name">{{goods.name}}</div>
                            <div class="order-price">￥{{goods.price}}</div>
                        </div>
                    </div>
                    <div class="order-type">{{item.order_type==9?'定制订单':'普通订单'}}</div>
                    <div class="order-total-price" v-if="item.refund">￥{{item.refund}}</div>
                    <div class="order-total-price" v-else>暂无</div>
                    <div class="order-state">
                        <template v-if="item.customized_status<10 && item.order_type==9">定制订单流程未结束<br>无法发起回收申请<br><router-link :to="{name:'cusOrderDetail',params:{order_id:item.order_id}}">订单详情</router-link></template>

                        <template v-if="item.customized_status==10&&item.curaftersales&&item.curaftersales.re_status&&item.curaftersales.re_status == 0">审核未通过，再次提交回收申请</template>
                        <template v-if="item.customized_status==10&&item.curaftersales&&item.curaftersales.re_status == 1">回收申请中，待审核</template>
                        <template v-if="item.customized_status==10&&item.curaftersales&&item.curaftersales.re_status == 2">回收申请已审核，待回收</template>
                        <template v-if="item.customized_status==10&&item.curaftersales&&item.curaftersales.re_status == 3">回收物料已寄出，待确认</template>
                        <template v-if="item.customized_status==10&&item.curaftersales&&item.curaftersales.re_status == 4">回收物料已入库，待退款</template>
                        <template v-if="item.customized_status==10&&item.curaftersales&&item.curaftersales.re_status == 5">已退款，待确认<br><span class="downloadbtn" style="cursor: pointer" @click="tuikuanp(item.order_id)">查看退款凭证</span></template>
                        <template v-if="item.customized_status==10&&item.curaftersales&&item.curaftersales.re_status == 6">确认收款，租赁完成</template>
                    </div>
                    <template  v-if="item.customized_status==10&&item.curaftersales&&item.curaftersales.re_status == 0" ><div  class="order-handle" @click="customerService(item.order_id,item.order_type)"><span>申请回收</span></div></template>
                    <div v-else-if="!item.curaftersales&&item.customized_status==10" class="order-handle" @click="customerService(item.order_id,item.order_type)"><span>申请回收</span></div>
                    <template v-else-if="item.curaftersales&&item.curaftersales.re_status == 2">
                        <router-link :to="{name:'currefundApply2',params:{order_id:item.order_id}}"><div  class="order-handle"><span>确认回收</span></div></router-link>
                    </template>

                    <div class="order-handle" @click="collectionConfirmation(item.order_id)" v-else-if="item.curaftersales&&item.curaftersales.re_status == 5"><span>确认收款</span></div>
                    <div v-else class="order-handle">无操作</div>
                </div>
            </div>
        </div>
        <template v-if="list.length>0">
            <Pagination :totalPage="totalPage" :limit="limit" @changePage="handOrderMore"></Pagination>
        </template>
        <el-dialog title="退款凭证" :visible.sync="dialogFormVisible2">
            <el-form :model="form2">

                <div v-html="tuikuaireadme"></div>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dialogFormVisible2 = false">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import Pagination from "@/components/common/Pagination.vue";
    import { timeToDate } from "@/utils";
    export default {
        name: "MyQuiteOrder",
        components: { Pagination },
        props: {},
        data() {
            return {
                searchOrder: "",
                page: 1,
                limit: 5,
                list: [],
                totalPage: 0,
                dialogFormVisible2:false,
                tuikuaireadme:"",
            };
        },
        watch: {},
        computed: {
            timeToValue() {
                return time => {
                    return timeToDate(time);
                };
            }
        },
        methods: {
            tuikuanp(id){
                let data={order_id:id}
                this.$api.getRefundedRM(data).then(res => {
                    if (res.status) {
                        this.dialogFormVisible2=true;
                        this.tuikuaireadme=res.data.readme;
                    }
                });
            },
            //确认收款
            collectionConfirmation(id){
                let data={order_id:id}
                this.$api.collectionConfirmation(data).then(res => {
                    if (res.status) {
                        this.$msg("提交成功");
                        this.$router.go(-1);
                    } else {
                        this.$msg(res.msg, "error");
                    }
                });
            },
            //申请售后
            customerService(id) {
                this.$router.push({ name: 'currefundApply', params: { order_id: id } })
            },
            getRefundList() {
                let data = {
                    page: this.page,
                    limit: this.limit
                };
                this.$api.afterCurSalesList(data).then(res => {
                    if (res.status) {
                        this.list = res.data.list;
                        this.totalPage = res.data.total_page;
                    }
                });
            },
            handOrderMore(val) {
                this.page = val;
                this.getRefundList();
            }
        },
        created() {},
        mounted() {
            this.getRefundList();
        }
    };
</script>
<style lang="scss" scoped>
    @import "@/assets/css/mixin.scss";
    @import "@/assets/css/variable.scss";
    .order-item {
        border: 1px solid $border;
        box-sizing: border-box;
        margin-bottom: 20px;
        .order-item-head {
            height: 40px;
            line-height: 40px;
            font-size: 12px;
            color: #757575;
            padding-left: 20px;
            border-bottom: 1px solid $border;
            .time {
                margin-right: 30px;
            }
            .code {
                margin-right: 30px;
            }
        }
    }
    .order-box {
        display: flex;
        flex-flow: row nowrap;
        justify-content: space-between;
        &.order-item-main {
            height: 100%;
            .order-info-list {
                border-right: 1px solid $border;
                width: 410px;
                .order-li {
                    display: flex;
                    align-items: center;
                    &:not(:last-of-type) {
                        border-bottom: 1px solid $border;
                    }
                    .order-img {
                        display: block;
                        width: 100px;
                        height: 100px;
                        object-fit: contain;
                        margin-right: 10px;
                    }
                    .order-name {
                        width: 200px;
                        line-height: 20px;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                        overflow: hidden;
                    }
                }
            }
            .order-type,
            .order-total-price,
            .order-state,
            .order-handle {
                padding-top: 40px;
            }
            .order-state {
                color: $theme-color;
            }
            .order-handle {
                cursor: pointer;
                &:hover {
                    color: $theme-color;
                }
            }
        }
        &.order-head {
            @include line-height(40px);
            border-top: 1px solid $border;
            border-bottom: 1px solid $border;
            margin: 20px 0;
        }
        .order-info {
            width: 310px;
            text-indent: 20px;
        }
        .order-price {
            width: 100px;
            text-align: center;
        }
        .order-num {
            width: 90px;
            text-align: center;
        }
        .order-type {
            width: 90px;
            text-align: center;
        }
        .order-total-price {
            width: 120px;
            text-align: center;
        }
        .order-state {
            width: 150px;
            text-align: center;
        }
        .order-handle {
            width: 150px;
            text-align: center;
        }
    }
    .wrapper {
        .top {
            display: flex;
            justify-content: space-between;
            padding-top: 20px;
            align-items: center;
            .tabs {
                .tab {
                    float: left;
                    padding: 0 20px;
                    cursor: pointer;
                    &:hover {
                        color: $theme-color;
                    }
                    &:first-of-type {
                        padding-left: 0;
                    }
                    &:not(:last-of-type) {
                        border-right: 1px solid $border;
                    }
                    &.active {
                        color: $theme-color;
                    }
                    span {
                        color: $theme-color;
                    }
                }
            }
            .search {
                width: 265px;
                height: 40px;
                background: rgba(255, 255, 255, 1);
                border: 1px solid rgba(220, 220, 220, 1);
                padding: 10px 0 10px 10px;
                box-sizing: border-box;
                display: flex;
                justify-content: space-between;
                align-items: center;
                transition: all 0.2s;
                position: relative;
                &.active {
                    border: 1px solid $theme-color;
                }
                .search-input {
                    display: block;
                    flex: 1;
                    height: 20px;
                }
                .search-icon-wrap {
                    display: inline-block;
                    width: 40px;
                    height: 40px;
                    position: relative;
                    border-left: 1px solid rgba(220, 220, 220, 1);
                    transition: all 0.2s;
                    cursor: pointer;
                    &:hover {
                        color: #fff;
                        background: $theme-color;
                    }
                    &.active {
                        border-color: $theme-color;
                    }
                    .search-icon {
                        position: absolute;
                        width: 20px;
                        height: 20px;
                        top: 10px;
                        left: 10px;
                        .el-icon-search {
                            font-size: 20px;
                        }
                    }
                }
            }
        }
    }
    .downloadbtn{ background: red; color: #fff; padding: 5px 10px; line-height: 26px; height: 26px;}
</style>